<div class="p-6 max-w-3xl space-y-8">

  <h1 class="text-2xl font-bold">Analyse post-événement</h1>

  <form class="bg-white dark:bg-slate-800 p-6 rounded-xl shadow space-y-6" (ngSubmit)="submit()">

    <div>
      <label class="block text-sm font-medium">Participants réels</label>
      <input
        type="number"
        [(ngModel)]="report.realAttendees"
        name="realAttendees"
        class="w-full mt-1 input"
      />
    </div>

    <div>
      <label class="block text-sm font-medium">Gaspillage (kg)</label>
      <input
        type="number"
        [(ngModel)]="report.wasteKg"
        name="wasteKg"
        class="w-full mt-1 input"
      />
    </div>

    <div>
      <label class="block text-sm font-medium">Satisfaction globale (/10)</label>
      <input
        type="number"
        max="10"
        [(ngModel)]="report.satisfaction"
        name="satisfaction"
        class="w-full mt-1 input"
      />
    </div>

    <button class="btn-primary">
      Valider l’analyse
    </button>

  </form>
</div>
